export function resolveLinkedInUrl(url: string) {
    const urlParts = url.split('/');
    if (!urlParts.includes('embed')) {
        const index = urlParts.indexOf('feed');
        return urlParts.slice(0, index).join('/') + '/embed/' + urlParts.slice(index).join('/');
    } else {
        return urlParts.join('/');
    }
}
